/* eslint-disable */
// @ts-nocheck
// This file was automatically generated by @repo/platform-manifest's Vite codegen plugin
// (packages/platform/manifest/src/vite-plugin.ts), driven by apps/web/vite.config.ts.
// You should NOT make any changes in this file as it will be overwritten on the next
// dev-server start or build. See reference/code-notes/REFACTOR-053-completion.md for the design.
//
// Packages absent from MOCK_ACTIVE_PACKAGE_IDS (apps/web/vite.config.ts) are simply absent
// below — never imported, so the bundler tree-shakes their code out entirely
// (architecture-refactor.md §7.4: "Non-licensed packages are absent from the generated
// manifest → never imported → tree-shaken out").

// (no active package has a web slice)
import { createRoute } from '@tanstack/react-router';
import { Route as __rootRoute } from "../routes/__root";

export const activeSliceIds = [];

export const activeSlices = [

];

export function mountActiveSlices(routeTree) {
  const existingChildren = Array.isArray(routeTree.children) ? routeTree.children : [];
  const sliceRoutes = activeSlices.map((slice) =>
    createRoute({
      getParentRoute: () => __rootRoute,
      path: '/__active-slices/' + slice.id,
      component: slice.component,
    }),
  );
  routeTree.addChildren([...existingChildren, ...sliceRoutes]);
}
